import React from 'react';
import { Route } from 'react-router';
import { useStore } from 'react-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import T from 'i18n';

const CONTAINER_SEGMENT_TO_STATE_KEY = {
  bundles: 'bundles',
  teamBundles: 'teamBundles',
  privateBundles: 'privateBundles',
  trialbundles: 'trialbooks',
  'court-bundles': 'courtBundles',
  'group-bundles': 'groupBundles',
  'quick-links': 'quickLinks',
};

const STOP_SEGMENTS = new Set(['files', 'annotationId', 'compositeKey']);

const findFolderTitle = (pathname = '', foldersByContainer = {}) => {
  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] !== 'case') return null;

  const containerIndex = segments.findIndex((seg) => CONTAINER_SEGMENT_TO_STATE_KEY[seg]);
  if (containerIndex === -1) return null;

  const containerSegment = segments[containerIndex];
  const containerCode = segments[containerIndex + 1];
  if (!containerCode) return null;

  const folderSegments = [];
  for (let i = containerIndex + 2; i < segments.length; i += 1) {
    const segment = segments[i];
    if (STOP_SEGMENTS.has(segment)) break;
    folderSegments.push(segment);
  }

  const rootFolders = foldersByContainer[CONTAINER_SEGMENT_TO_STATE_KEY[containerSegment]];
  if (!Array.isArray(rootFolders) || rootFolders.length === 0) return null;

  const pathCodes = [containerCode, ...folderSegments];
  let currentFolder = rootFolders.find((folder) => folder?.code === pathCodes[0]);
  if (!currentFolder) return null;

  for (let i = 1; i < pathCodes.length; i += 1) {
    const children = currentFolder?.folders;
    if (!Array.isArray(children) || children.length === 0) break;
    const next = children.find((folder) => folder?.code === pathCodes[i]);
    if (!next) break;
    currentFolder = next;
  }

  return currentFolder?.name || null;
};

const CustomRoute = React.memo(
  ({ component: Component, render, computedMatch, routeChanged, title, ...rest }) => {
    const store = useStore();
    store.dispatch(routeChanged({ ...computedMatch, location: rest.location }));

    const state = store.getState();
    const folderTitle = findFolderTitle(rest.location?.pathname, state?.case?.folders);
    const translatedTitle =
      typeof title === 'function'
        ? title(computedMatch.params)
        : T.translate(title) || document.title;

    document.title = folderTitle || translatedTitle;

    return (
      <Route
        {...rest}
        render={(props) => {
          return render ? render(props) : <Component {...props} />;
        }}
      />
    );
  },
);

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    routeChanged: bindActionCreators({ ...actions }, dispatch).routeChanged,
  };
}

export default connect(null, mapDispatchToProps)(CustomRoute);
